import MainLayout from "@/components/layout/company/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
// import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
// const convertNumberService = new ConvertNumService();

export default {
    name: "companyIndex",

    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobList: {},
            topCategories: [
                { category_id: '', category_name: 'Software' },
                { category_id: '', category_name: 'Marketing' },
                { category_id: '', category_name: 'Accounting' },
                { category_id: '', category_name: 'Sales & HR' },
                { category_id: '', category_name: 'Engineering' }
            ],
            count: "",
            regionArr: RegionJson,
            isCategoryDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            isRegionDropdownOpen: false,
            keyword: {
                job_title: "",
                job_type: "",
                category_name: "",
                region: ""
            },
            page_status: false,
            category: [],
            job_count: "",
            isSearched: false,
            displayPeopleCount: 0,
            displayJobCount: 0,
            displayCompanyCount: 0,
            activeFaq: 0,
        };
    },

    computed: {
        selectedCategoryName() {
            if (!this.category || !Array.isArray(this.category)) return '';
            const selected = this.category.find(cat => cat.id === this.keyword.category_name);
            return selected ? selected.category_name : '';
        },

        selectedJobTypeName() {
            const types = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job',
            };
            return types[this.keyword.job_type] || '';
        },

        selectedRegionName() {
            if (this.keyword.region === '' || this.keyword.region === null || this.keyword.region === undefined) {
                return '';
            }
            return this.regionArr[this.keyword.region] || '';
        },

        displayedJobs() {
            if (this.isSearched) {
                return this.jobList && this.jobList.data ? this.jobList.data : [];
            } else {
                return Array.isArray(this.jobList) ? this.jobList : [];
            }
        },

        activeFiltersList() {
            const list = [];
            if (this.keyword.job_title) {
                list.push({ type: 'job_title', label: `"${this.keyword.job_title}"` });
            }
            if (this.keyword.category_name && this.selectedCategoryName) {
                list.push({ type: 'category_name', label: `"${this.selectedCategoryName}"` });
            }
            if (this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined && this.selectedRegionName) {
                list.push({ type: 'region', label: `"${this.selectedRegionName}"` });
            }
            if (this.keyword.job_type && this.selectedJobTypeName) {
                list.push({ type: 'job_type', label: `"${this.selectedJobTypeName}"` });
            }
            return list;
        }
    },

    methods: {
        // getAllJobs(page = 1) {
        //     axios.get("/applicant/job/list?page=" + page)
        //         .then(response => {
        //             this.jobList = response.data;
        //             this.job_count = convertNumberService.convertEng2Mm(this.jobList.total.toString())
        //         })
        //         .catch(error => {
        //             console.log("Get Jobs API Error", error);
        //         });
        // },

        getLatestJobs() {
            axios.get("/applicant/job/latestlist")
                .then(response => {
                    this.jobList = response.data;
                    // this.job_count = convertNumberService.convertEng2Mm(this.jobList.total.toString())
                })
                .catch(error => {
                    console.log("Get Jobs API Error", error);
                });
        },

        getCategory() {
            axios.get("/job/category/list")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Get Category API Error", error);
                })
        },

        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        handleSearchSubmit() {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            if (!this.keyword.job_title && !this.keyword.category_name && !hasRegion && !this.keyword.job_type) {
                this.clearSearch();
            } else {
                this.searchJob();
            }
        },

        searchJob(page = 1) {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            if (!this.keyword.job_title && !this.keyword.category_name && !hasRegion && !this.keyword.job_type) {
                this.clearSearch();
                return;
            }
            var request = {
                params: {
                    keyword: this.keyword.job_title,
                    keyword1: this.keyword.category_name,
                    keyword2: hasRegion ? this.keyword.region : '',
                    keyword3: this.keyword.job_type,
                    per_page: 30,
                }
            }
            axios.get("/applicant/search/jobresult?page=" + page, request)
                .then(response => {
                    this.isSearched = true;
                    this.jobList = response.data || {};
                    this.oldKeyword = request.params;

                    this.$nextTick(() => {
                        const jobsSection = document.querySelector('.company-index-section');
                        if (jobsSection) {
                            jobsSection.scrollIntoView({ behavior: 'smooth' });
                        }
                    });
                })
                .catch(error => {
                    console.log("Job Search API Error", error);
                });
        },

        clearSearch() {
            this.keyword.job_title = '';
            this.keyword.category_name = '';
            this.keyword.region = '';
            this.keyword.job_type = '';
            this.isSearched = false;
            this.getLatestJobs();

            this.$nextTick(() => {
                const jobsSection = document.querySelector('.company-index-section');
                if (jobsSection) {
                    jobsSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },

        getJobType(job_type) {
            const jobTypes = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job'
            };
            return jobTypes[job_type] || 'သတ်မှတ်ထားခြင်းမရှိပါ';
        },

        goFB(id) {
            window.open("https://www.facebook.com/sharer/sharer.php?u=https://bib-job.com/job_listing/job_detail/"+id+"&t="+document.title, '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=500');
        },

        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isJobTypeDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectCategory(id) {
            this.keyword.category_name = id;
            this.isCategoryDropdownOpen = false;
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectJobType(id) {
            this.keyword.job_type = id;
            this.isJobTypeDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.keyword.region = id;
            this.isRegionDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
                this.isRegionDropdownOpen = false;
            }
        },

        getTopCategories() {
            axios
                .get('/category/info?page=1')
                .then((response) => {
                    this.topCategories = response.data.data.slice(0, 5);
                })
                .catch((error) => {
                    console.log('Get Top Categories API Error', error);
                });
        },

        searchByCategory(cat) {
            this.keyword.job_title = '';
            if (typeof cat === 'object' && cat !== null) {
                if (cat.category_id) {
                    this.keyword.category_name = cat.category_id;
                } else {
                    const found = this.category.find(c =>
                        c.category_name && c.category_name.toLowerCase().includes(cat.category_name.toLowerCase())
                    );
                    if (found) {
                        this.keyword.category_name = found.id;
                    } else {
                        this.keyword.job_title = cat.category_name;
                    }
                }
            } else {
                this.keyword.category_name = cat;
            }
            this.keyword.region = '';
            this.keyword.job_type = '';
            this.searchJob();
        },

        animateStats() {
            const duration = 2000;
            const targets = {
                people: 100,
                jobs: 500,
                companies: 150,
            };

            const startTime = performance.now();

            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1);
                const ease = 1 - Math.pow(1 - progress, 3);

                this.displayPeopleCount = Math.floor(ease * targets.people);
                this.displayJobCount = Math.floor(ease * targets.jobs);
                this.displayCompanyCount = Math.floor(ease * targets.companies);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.displayPeopleCount = targets.people;
                    this.displayJobCount = targets.jobs;
                    this.displayCompanyCount = targets.companies;
                }
            };

            requestAnimationFrame(animate);
        },

        toggleFaq(index) {
            if (this.activeFaq === index) {
                this.activeFaq = null;
            } else {
                this.activeFaq = index;
            }
        },

        initStatsObserver() {
            this.$nextTick(() => {
                const statsSection = document.querySelector('.sec-stats');
                if (!statsSection) {
                    this.animateCounts();
                    return;
                }

                if ('IntersectionObserver' in window) {
                    this.statsObserver = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && !this.animated) {
                                this.animateCounts();
                                if (this.statsObserver) {
                                    this.statsObserver.unobserve(entry.target);
                                }
                            }
                        });
                    }, { threshold: 0.2 });

                    this.statsObserver.observe(statsSection);
                } else {
                    this.animateCounts();
                }
            });
        },
    },

    mounted() {
        this.getCategory();
        // this.getAllJobs();
        this.getLatestJobs();
        this.getTopCategories();
        this.animateStats();
        this.initStatsObserver();
        window.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
